module.exports = __webpack_public_path__ + "img/shield-minus.b41a4d56.svg";